import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Offcanvas, OffcanvasBody, Spinner } from "reactstrap";
import { AlertTriangle, X, Ban } from "lucide-react";
import { updatePackageStatus } from "../../api/packages";
import { showToast } from "../../utils/showToast";
import "./cancelPackage.scss";

export default function CancelPackage({ isOpen, defaultData, closeModal, updateData }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const close = () => {
    if (loading) return;
    closeModal(false);
  };

  const receiver = `${defaultData?.receiver_name || ""} ${defaultData?.receiver_lastName || ""}`.trim();
  const comuna = defaultData?.shipping_address?.municipality?.name;

  const confirmCancel = async () => {
    setLoading(true);
    const { data, error } = await updatePackageStatus({ status: 5, id: defaultData?._id });
    setLoading(false);
    if (data) {
      showToast(t("Pedido anulado correctamente."), true);
      updateData?.(true);
      closeModal(false);
    } else if (error) {
      showToast(t("No se pudo anular el pedido. Intenta nuevamente."), false);
    }
  };

  return (
    <Offcanvas isOpen={isOpen} toggle={close} direction="end" className="cd-drawer">
      <div className="cd-drawer__head">
        <h2 className="cd-drawer__title">{t("Anular pedido")}</h2>
        <button type="button" className="cd-drawer__close" onClick={close} aria-label={t("Cerrar")}>
          <X size={18} />
        </button>
      </div>

      <OffcanvasBody className="cd-drawer__body">
        <div className="cd-alert">
          <span className="cd-alert__icon" aria-hidden="true">
            <AlertTriangle size={20} />
          </span>
          <div>
            <p className="cd-alert__title">{t("Esta acción no se puede deshacer")}</p>
            <p className="cd-alert__text">
              {t("El pedido quedará anulado y no se realizará la entrega. El destinatario no recibirá el paquete.")}
            </p>
          </div>
        </div>

        {defaultData && (
          <div className="cd-order">
            <div className="cd-order__row">
              <span className="cd-order__label">{t("Pedido")}</span>
              <span className="cd-order__value cd-mono">#{defaultData.followingNumber}</span>
            </div>
            {receiver && (
              <div className="cd-order__row">
                <span className="cd-order__label">{t("Destinatario")}</span>
                <span className="cd-order__value">{receiver}</span>
              </div>
            )}
            {comuna && (
              <div className="cd-order__row">
                <span className="cd-order__label">{t("Comuna")}</span>
                <span className="cd-order__value">{comuna}</span>
              </div>
            )}
            {defaultData.order_id && (
              <div className="cd-order__row">
                <span className="cd-order__label">{t("N° de venta")}</span>
                <span className="cd-order__value cd-mono">{defaultData.order_id}</span>
              </div>
            )}
          </div>
        )}
      </OffcanvasBody>

      <div className="cd-drawer__footer">
        <button type="button" className="cd-btn cd-btn--ghost" onClick={close} disabled={loading}>
          {t("Volver")}
        </button>
        <button type="button" className="cd-btn cd-btn--danger" onClick={confirmCancel} disabled={loading}>
          {loading ? <Spinner size="sm" /> : <Ban size={16} />}
          {loading ? t("Anulando…") : t("Anular pedido")}
        </button>
      </div>
    </Offcanvas>
  );
}
